/* eslint-disable */
import { produce } from "immer";
import {
  RETIREMENT_IDENTITY_FETCH_FAILURE,
  RETIREMENT_IDENTITY_FETCH_SUCCESS,
  RETIREMENT_IDENTITY_FETCH_START,
} from "../actions/types";

const retirementIdentity = (
  state = {
    fetching: false,
    data: [],
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case RETIREMENT_IDENTITY_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case RETIREMENT_IDENTITY_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case RETIREMENT_IDENTITY_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default retirementIdentity;
